"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dashboard;

var _react = _interopRequireDefault(require("react"));

var _clientAuth = require("@devsta/client-auth");

var _VideoList = _interopRequireDefault(require("../../../common/components/VideoList"));

require("../styles/_video-dashboard.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Dashboard() {
  return /*#__PURE__*/_react.default.createElement(_VideoList.default, {
    summaryTitle: "Welcome back, ".concat(_clientAuth.credentials.get().user.firstName),
    summarySubtitle: "Here are your videos for today.",
    headerSubtitle: "Home",
    headerTitle: "Projects",
    summaryCards: [{
      label: 'Editing In Progress',
      status: ['EDITING', 'INTERNAL_REVIEW']
    }, {
      label: 'Pending Review',
      status: 'PENDING_REVIEW'
    }, {
      label: 'On Hold',
      status: 'ON_HOLD'
    }]
  });
}